export enum LikertType {
  numeric = 'numeric'
}

export enum LikertSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}

export enum LikertVariant {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  info = 'info',
  warning = 'warning',
  danger = 'danger',
  low = 'low',
  high = 'high'
}

export interface Step {
  index: number;
  classMap: {
    [key: string]: boolean;
  };
  value: string;
  icon?: string;
  hint?: string;
  selected?: boolean;
}

export interface LikertValue {
  value: string;
  max: number;
}

export type CssClassMap = { [className: string]: boolean };
